<template>
    <div class="workordrAssign" style="margin-bottom:12px">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>审核承办单位向指挥中心提交的处置结果
        </div>
        <div class="workordr_content" v-for="(item ,index) in queryWordorderMessageData">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>承办单位处理结果</p>
                </div>
            </div>
            <div class="workordr_result">
                <div class="workordr_result_title">
                    <span class="icon-build"></span>
                    <span>
                       {{item.czCzdwmc}}
                    </span>
                    <span><el-icon><clock/></el-icon></span>
                    <span>
                       {{item.updateTime}}
                    </span>
                </div>
                <div class="workordr_result_main">
                    {{item.czCzjgwb}}
                </div>
            </div>
        </div>
    </div>
    <div class="workordrAssign">
        <div class="workordr_content">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>处置结果</p>
                    <el-radio-group v-model="ruleForm.czCzjgzt" @change="radioGroupChange">
                        <el-radio-button label="1">通过</el-radio-button>
                        <el-radio-button label="0">驳回</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <el-form label-width="90px"
                     :model="ruleForm"
                     :rules="rules"
                     label-position="left"
                     ref="ruleFormRef">
                <div class="workordr_main">
                    <el-form-item label="处理结果" v-if="ruleForm.czCzjgzt=='1'" prop="czCzjgwb">
                        <el-input v-model="ruleForm.czCzjgwb" :autosize="{ minRows: 5}" maxlength="2000" show-word-limit type="textarea"/>
                    </el-form-item>
                    <el-form-item label="驳回原因" v-else prop="czCzjgwb">
                        <el-input v-model="ruleForm.czCzjgwb" :autosize="{ minRows: 5}" maxlength="2000" show-word-limit type="textarea"/>
                    </el-form-item>
                    <Workorder_file paddingLeft="90" @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, computed, ref, getCurrentInstance, onMounted,watch} from 'vue'
    import {useStore} from 'vuex';
    import {ElMessageBox,ElLoading} from 'element-plus'
    import Workorder_file from './Wordorder_file.vue';
    export default {
        name: "WorkorderCzjgsh_ZGLD",
        props: ["gdId"],
        components: {
            Workorder_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": 'JGSH',
                "gdId": props.gdId,
                "czCzjgwb": "",
                "czCzjgzt": "1",
            });

            let queryWordorderMessageData = ref([])
            const rules = reactive({
                czCzjgwb: [
                    {required: true, message: "请输入处理结果", trigger: 'blur'},
                ]
            });
            watch(()=>ruleForm.czCzjgzt,(newVal)=>{
                if(newVal =="1"){
                    rules.czCzjgwb[0].message="请输入处理结果"
                }else{
                    rules.czCzjgwb[0].message="请输入驳回原因"
                }
            })
            const radioGroupChange = (param) => {
                // debugger
                // if (param == 1) {
                //     ruleForm.czCzjgwb = "";
                // }
            }
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent");
                                        store.state.addNewWorkorderSuccess=true;
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            onMounted(() => {
                // queryWordorderMessage();
            })
            const queryWordorderMessage = () => {
                proxy.$axios.post("/jgfast/wgsj/selBshczsj", {
                    "gdId": props.gdId,
                }).then((res) => {
                    queryWordorderMessageData.value = res.data;
                });
            }
            //取消事件
            const cancleClick = () => {
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            return {
                ruleForm,
                rules,
                ruleFormRef,
                submitForm,
                queryWordorderMessageData,
                cancleClick,
                fileListToParent,
                deleteFile,
                radioGroupChange
            }
        }
    }
</script>

<style scoped>

</style>
